import { render, staticRenderFns } from "./ProformaInvoicesTable.vue?vue&type=template&id=acea0ed2"
import script from "./ProformaInvoicesTable.vue?vue&type=script&lang=js"
export * from "./ProformaInvoicesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports